import React, { useMemo } from "react";
import { Alert, Button, Input, Label, Spinner } from "reactstrap";
import InventoryFiltersDrawer from "./InventoryFiltersDrawer";
import { InventoryCategory, InventoryExtraSelect, InventoryFilterOption } from "./InventoryFiltersPanel";

type StockTransferenciasFiltersDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedTipos: InventoryFilterOption[];
  onSelectedTiposChange: (next: readonly InventoryFilterOption[]) => void;
  options: InventoryFilterOption[];
  categories: InventoryCategory[];
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  onClear: () => void;
  disabled: boolean;
  fechaDesde: string;
  fechaHasta: string;
  onFechaDesdeChange: (value: string) => void;
  onFechaHastaChange: (value: string) => void;
  onConsultar: () => void;
  disableConsultar: boolean;
  loadingMovimientos: boolean;
  errorMovimientos: string | null;
  idMovOptions: InventoryFilterOption[];
  selectedIdMovs: InventoryFilterOption[];
  onIdMovChange: (next: readonly InventoryFilterOption[]) => void;
  familiaOptions: InventoryFilterOption[];
  selectedFamilias: InventoryFilterOption[];
  onFamiliaChange: (next: readonly InventoryFilterOption[]) => void;
  lineaOptions: InventoryFilterOption[];
  selectedLineas: InventoryFilterOption[];
  onLineaChange: (next: readonly InventoryFilterOption[]) => void;
  serverOptions: InventoryFilterOption[];
  selectedServers: InventoryFilterOption[];
  onServerChange: (next: readonly InventoryFilterOption[]) => void;
  recibeOptions: InventoryFilterOption[];
  selectedRecibes: InventoryFilterOption[];
  onRecibeChange: (next: readonly InventoryFilterOption[]) => void;
  descripcionOptions: InventoryFilterOption[];
  selectedDescripciones: InventoryFilterOption[];
  onDescripcionChange: (next: readonly InventoryFilterOption[]) => void;
};

const StockTransferenciasFiltersDrawer: React.FC<StockTransferenciasFiltersDrawerProps> = ({
  isOpen,
  onClose,
  selectedTipos,
  onSelectedTiposChange,
  options,
  categories,
  activeCategory,
  onCategoryChange,
  onClear,
  disabled,
  fechaDesde,
  fechaHasta,
  onFechaDesdeChange,
  onFechaHastaChange,
  onConsultar,
  disableConsultar,
  loadingMovimientos,
  errorMovimientos,
  idMovOptions,
  selectedIdMovs,
  onIdMovChange,
  familiaOptions,
  selectedFamilias,
  onFamiliaChange,
  lineaOptions,
  selectedLineas,
  onLineaChange,
  serverOptions,
  selectedServers,
  onServerChange,
  recibeOptions,
  selectedRecibes,
  onRecibeChange,
  descripcionOptions,
  selectedDescripciones,
  onDescripcionChange,
}) => {
  const filtersHeaderExtras = (
    <>
      <div className="mb-3">
        <Label className="form-label">Desde</Label>
        <Input type="date" value={fechaDesde} onChange={(event) => onFechaDesdeChange(event.target.value)} />
      </div>
      <div className="mb-3">
        <Label className="form-label">Hasta</Label>
        <Input type="date" value={fechaHasta} onChange={(event) => onFechaHastaChange(event.target.value)} />
      </div>
      <Button color="primary" className="w-100" disabled={disableConsultar} onClick={onConsultar}>
        {loadingMovimientos ? (
          <>
            <Spinner size="sm" className="me-2" /> Consultando
          </>
        ) : (
          "Consultar"
        )}
      </Button>
      {errorMovimientos ? (
        <Alert color="danger" className="mt-3 mb-0">
          {errorMovimientos}
        </Alert>
      ) : null}
    </>
  );

  const filtersExtraSelects = useMemo<InventoryExtraSelect[]>(
    () => [
      {
        id: "idmovimiento",
        label: "ID Movimiento",
        options: idMovOptions,
        selected: selectedIdMovs,
        onChange: onIdMovChange,
      },
      {
        id: "familia",
        label: "Familia",
        options: familiaOptions,
        selected: selectedFamilias,
        onChange: onFamiliaChange,
      },
      {
        id: "linea",
        label: "Línea",
        options: lineaOptions,
        selected: selectedLineas,
        onChange: onLineaChange,
      },
      {
        id: "server",
        label: "Servidor",
        options: serverOptions,
        selected: selectedServers,
        onChange: onServerChange,
      },
      {
        id: "recibe",
        label: "Recibe",
        options: recibeOptions,
        selected: selectedRecibes,
        onChange: onRecibeChange,
      },
      {
        id: "descripcion",
        label: "Descripción",
        options: descripcionOptions,
        selected: selectedDescripciones,
        onChange: onDescripcionChange,
      },
    ],
    [
      descripcionOptions,
      familiaOptions,
      idMovOptions,
      lineaOptions,
      onServerChange,
      onDescripcionChange,
      onFamiliaChange,
      onIdMovChange,
      onLineaChange,
      onRecibeChange,
      recibeOptions,
      selectedDescripciones,
      selectedFamilias,
      selectedIdMovs,
      selectedLineas,
      selectedServers,
      selectedRecibes,
      serverOptions,
    ],
  );

  return (
    <InventoryFiltersDrawer
      isOpen={isOpen}
      onClose={onClose}
      selectedOptions={selectedTipos}
      onSelectedOptionsChange={onSelectedTiposChange}
      options={options}
      categories={categories}
      activeCategory={activeCategory}
      onCategoryChange={onCategoryChange}
      onClear={onClear}
      disabled={disabled}
      extraSelects={filtersExtraSelects}
      headerExtras={filtersHeaderExtras}
    />
  );
};

export default StockTransferenciasFiltersDrawer;
